import { httpClient } from "@/services";
import options from "@/store/modules/statistics/safetyStatistic/options";
import getChartDataSafetyStatistic from "@/store/modules/statistics/safetyStatistic/getChartDataSafetyStatistic";
export default {
	state: {
		safetyStatisticGraphOptions: options,
		safetyStatisticGraphData: null,
		safetyStatisticDate: null,
		safetyStatisticRow: null,
	},
	mutations: {
		updateSafetyStatisticStart(state, { month }) {
			const date = [];
			const labels = [];
			const drivers = [];
			const company = [];

			for (const item of month) {
				date.push(item.date);
				labels.push(item.name);
				drivers.push(item.drivers);
				company.push(item.company);
			}

			state.safetyStatisticDate = date;
			state.safetyStatisticGraphData = getChartDataSafetyStatistic({ labels, drivers, company });

		},
		updateSafetyStatisticList(state, { row }) {
			state.safetyStatisticRow = row;

		}
	},
	actions: {
		async getSafetyStatistic({ commit }) {
			try {
				const { data } = await httpClient.post('/safety/statistic');
				if (data) {
					commit('updateSafetyStatisticStart', data);
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getSafetyStatisticDate({ commit }, value) {
			try {
				const { data } = await httpClient.post(`/safety/statistic/${ value }`);
				if (data) commit('updateSafetyStatisticList', data);
			} catch (e) {
				console.error(e);
			}
		},
		async getSafetyStatisticYear({ commit }, value) {
			try {
				const { data } = await httpClient.post(`/safety/statistic/`, value);
				if (data) {
					commit('updateSafetyStatisticStart', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async updateSafetyStatistic({ commit }) {
			try {
				const { data } = await httpClient.get(`/safety/statistic/update`);
				if (data) {
					commit('updateSafetyStatisticStart', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
	},

	getters: {
		safetyStatisticGraphOptions: (s) => s.safetyStatisticGraphOptions,
		safetyStatisticGraphData: (s) => s.safetyStatisticGraphData,
		safetyStatisticDate: (s) => s.safetyStatisticDate,
		safetyStatisticRow: (s) => s.safetyStatisticRow,

	}
};
